var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonBorderreact = function SvgButtonBorderreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1216 82"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 162",
    d: "M1201.944 38.864a3.007 3.007 0 0 0 .049 4.52c.129.112.25.232.363.344a11.187 11.187 0 0 1 2.334 4.248c.638 1.9 2.406 4.936 2.406 9.1 0 3.744.2 6.184.589 7.328a4.058 4.058 0 0 0 1.954 2.408q1.345.7 5.361.712v13.48H1V67.52q4.118 0 5.474-.712A4.029 4.029 0 0 0 8.428 64.4q.593-1.716.589-7.328c0-4.16 1.768-7.192 2.414-9.1a11.187 11.187 0 0 1 2.333-4.248c.113-.112.234-.232.363-.344a3.013 3.013 0 0 0 .048-4.52c-.04-.032-.081-.072-.121-.1a9.8 9.8 0 0 1-2.406-3.96c-.759-2.136-2.6-5.072-2.624-8.8a46.307 46.307 0 0 0-.339-6.848A6.1 6.1 0 0 0 6.82 15.76a6.007 6.007 0 0 0-3.948-1.1H1V1h1214v13.656h-1.76a6.037 6.037 0 0 0-3.948 1.1 6.14 6.14 0 0 0-1.857 3.392 46.311 46.311 0 0 0-.339 6.848c-.024 3.728-1.865 6.664-2.624 8.8a9.794 9.794 0 0 1-2.406 3.96c-.041.036-.082.076-.122.108Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })));
};

export default SvgButtonBorderreact;